import { render, staticRenderFns } from "./ShelfLabelPaper.vue?vue&type=template&id=bc313c46&scoped=true&"
import script from "./ShelfLabelPaper.vue?vue&type=script&lang=js&"
export * from "./ShelfLabelPaper.vue?vue&type=script&lang=js&"
import style0 from "./ShelfLabelPaper.vue?vue&type=style&index=0&id=bc313c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc313c46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VRow,VSheet})
